var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 9a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5m0-1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18c3.314 0 6-1.679 6-3.75s-2.686-3.75-6-3.75c-1.419 0-2.723.308-3.75.822v1.757q.134-.105.302-.209c.812-.507 2.027-.87 3.448-.87s2.636.363 3.448.87c.833.521 1.052 1.048 1.052 1.38s-.22.859-1.052 1.38c-.812.507-2.027.87-3.448.87a8 8 0 0 1-.75-.034v1.505q.369.03.75.029"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 13.5a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5m0-1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M7.5 22.5c3.314 0 6-1.679 6-3.75S10.814 15 7.5 15s-6 1.679-6 3.75 2.686 3.75 6 3.75m3.448-2.37C11.78 19.609 12 19.082 12 18.75s-.22-.859-1.052-1.38c-.812-.507-2.027-.87-3.448-.87s-2.636.363-3.448.87C3.22 17.891 3 18.418 3 18.75s.22.859 1.052 1.38c.812.507 2.027.87 3.448.87s2.636-.363 3.448-.87",
    clipRule: "evenodd"
  })));
};
export default SvgUsers;